<template>
  <div id="map_container" class="map_container"></div>
</template>

<script>
import {initMap} from "@/utils/mapUtil/funcs";
import {mapGetters} from "vuex";
import L from 'leaflet'
import 'leaflet.heat'
import {addMapMarkers, handleZoomForBoundary} from "@/utils/mapUtil/leafletFun";
import {layerServiceURL} from "@/utils/mapUtil/layerServiceURL";
import { wgs84togcj02, gcj02towgs84 } from 'coordtransform'

export default {
  name: "LeafletMap",
  computed: {
    ...mapGetters(["topSelectAreacode", 'topSelectAreaname', 'identityObj']),
  },
  props: {
    polygonData: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      map: null,
      areaCode: '',
    }
  },
  methods: {
    // 根据缩放层级加载对应的行政区划边界，并清除其他层级的边界
    handleZoomEnd() {

      const zoomRanges = [
        {layerType: 'service', range: [12, 20], ...layerServiceURL['china_township']},
      ];
      handleZoomForBoundary(this.map, this, zoomRanges)
    },

    // 加载所有地图
    initAllMap() {
      // 行政区边界
      // addMapMarkers(this.map, this.identityObj.areaFullName, this.identityObj.areaName, this.identityObj.centerPoint)
    },

    addLandPolygon(polygonData) {
      // 将 [纬度, 经度] 转换为 [经度, 纬度] 并构建 GeoJSON FeatureCollection
      console.log(polygonData, 'polygonData')
      const geoJsonFeature = {
        "type": "FeatureCollection",
        "features": polygonData.map(polygon => {
          console.log(polygon, 'polygon');

          // 假设每个地块面积为 1000㎡，你可以根据实际数据传入面积字段
          const area = this.calculatePolygonArea(polygon);

          const coordinates = polygon.map(point => {
            const [lat, lng] = point;
            return gcj02towgs84(lng, lat); // 反转为 [经度, 纬度]
          });

          // 计算多边形中心点（简单平均法）
          const sumLng = coordinates.reduce((sum, p) => sum + p[0], 0);
          const sumLat = coordinates.reduce((sum, p) => sum + p[1], 0);
          const center = L.latLng(sumLat / coordinates.length, sumLng / coordinates.length);

          // 构建 GeoJSON Polygon
          const geometry = {
            "type": "Polygon",
            "coordinates": [coordinates]
          };
          console.log(coordinates, 'coordinates')



          // 创建带面积文字的图标
          const areaIcon = L.divIcon({
            className: 'leaflet-div-icon area-label',
            html: `${area}亩`,
            iconSize: [80, 20],
            iconAnchor: [20, 10]
          });

          // 添加标记到地图
          L.marker(center, {icon: areaIcon}).addTo(this.map);

          return {
            "type": "Feature",
            "properties": {area},
            "geometry": geometry
          };
        })
      };

      // 渲染面要素
      const geoJsonLayer = L.geoJSON(geoJsonFeature, {
        style: () => ({
          color: "#ff7800",
          weight: 2,
          fillColor: "#ff7800",
          fillOpacity: 0.5
        })
      }).addTo(this.map);

      // 自动缩放到面范围
      if (geoJsonLayer.getBounds && !this.map.getBounds().contains(geoJsonLayer.getBounds())) {
        this.map.fitBounds(geoJsonLayer.getBounds());
      }
    },

    // 计算面积方法
    calculatePolygonArea(coordinates) {
      // 验证输入
      if (!Array.isArray(coordinates) || coordinates.length < 3) {
        throw new Error("至少需要3个坐标点");
      }

      // 1. 计算地理中心点（质心）
      let lonSum = 0;
      let latSum = 0;
      for (const point of coordinates) {
        if (!Array.isArray(point) || point.length < 2 || typeof point[0] !== 'number' || typeof point[1] !== 'number') {
          throw new Error("每个坐标点应为[经度, 纬度]数组");
        }
        lonSum += point[1];
        latSum += point[0];
      }
      const centerLon = lonSum / coordinates.length;
      const centerLat = latSum / coordinates.length;

      // 2. 坐标转换参数（参考WGS84坐标系）
      const earthRadius = 6371000; // 地球半径（米）
      const metersPerDegreeLat = (Math.PI / 180) * earthRadius; // 纬度每度距离
      const metersPerDegreeLon = metersPerDegreeLat * Math.cos(centerLat * Math.PI / 180); // 经度每度距离

      // 3. 转换为平面坐标（单位：米）
      const projectedPoints = coordinates.map(point => {
        const dx = (point[1] - centerLon) * metersPerDegreeLon;
        const dy = (point[0] - centerLat) * metersPerDegreeLat;
        return [dx, dy];
      });

      // 4. 使用鞋带公式计算面积
      let area = 0;
      const n = projectedPoints.length;
      for (let i = 0; i < n; i++) {
        const [x1, y1] = projectedPoints[i];
        const [x2, y2] = projectedPoints[(i + 1) % n]; // 下一个点（自动首尾相连）
        area += x1 * y2 - x2 * y1;
      }

      // 5. 处理结果（取绝对值并转换单位）
      const areaSquareMeters = Math.abs(area) / 2; // 平方米
      const areaMu = areaSquareMeters / 666.67;    // 转换为亩（1亩 = 666.67平方米）

      return parseFloat(areaMu.toFixed(2));
    }




    // 土地流转热力图
  },
  mounted() {
    this.areaCode = this.identityObj.areaCode;
    this.map = initMap("map_container")
    // 添加初始地图
    this.initAllMap()
    // 监听地图缩放事件 根据缩放层级加载对应的行政区划边界，并清除其他层级的边界
    this.map.on('zoomend', this.handleZoomEnd);

    // 如果有 polygonData，则加载面数据
    if (this.polygonData && this.polygonData.length > 0) {
      this.addLandPolygon(this.polygonData);
    }
  },
}
</script>

<style lang="less">

.area-label {
  color: #141515;
  //background-color: white;
  //border: 1px solid #999;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  pointer-events: none; /* 防止点击干扰地图交互 */
}

.map_container {
  width: 100%;
  height: 100%;
}
</style>
